<template>
  <div id="pricematrix-container">

    <div id="pricematrix">

      <!--left part: Standard, EXPERT, PRESTIGE-->
      <div v-if="!nurnachhaltig" id="produkte">

        <div id="produkte-headerline">

          <span class="tile--left">&nbsp;</span>
          <span v-for="productHead in matrixDefinition.columnHeaders"
                :key="'Head' + productHead"
                class="tile--top tile--middle">

            <v-tooltip top
                       nudge-bottom="16">
              <template v-slot:activator="{on}">
                <span class="pt8"
                      v-on="on">{{ productHead }}</span>
              </template>
              <span class="caption">Tarifname</span>
            </v-tooltip>

          </span>
        </div>

        <div id="produkte-matrix">

          <v-row v-for="sbrow in matrixDefinition.rows"
                    :key="'sbrow'+sbrow"
                    no-gutters
                    class="sb--row flex-nowrap">

            <div class="tile--left">

              <v-tooltip top
                         nudge-bottom="16">
                <template v-slot:activator="{on}">
                  <span class="pt8"
                        v-on="on">{{ sbrow === '0' && tarifIsCharta(statePath) ? '50' : sbrow }} €</span>
                </template>
                <span class="caption">Selbstbeteiligung</span>
              </v-tooltip>

            </div>

            <template v-for="productLine in matrixDefinition.productLines">

              <div v-if="matrixAvailabilities['SB' + sbrow][productLine] === true"
                   :key="productLine + '-' + sbrow"
                   :class="matrixSelection===productLine + '-' + sbrow ? 'selected' : ''"
                   class="tile--middle selectable"
                   @click="onSelectPrice(productLine + '-' + sbrow)">
                <div>
                  {{ $helpers.toGermanFloatString(matrixPraemien['SB' + sbrow][productLine]) }}&nbsp;€
                </div>

              </div>


              <div v-else-if="matrixAvailabilities['SB' + sbrow][productLine] === 'schublade'"
                   :key="productLine + '-' + sbrow"
                   :class="matrixSelection===productLine + '-' + sbrow ? 'selected' : ''"
                   class="tile--middle selectable"
                   @click="onSelectPrice(productLine + '-' + sbrow)">
                <v-tooltip top
                           nudge-bottom="8">
                  <template v-slot:activator="{on}">
                    <div class="warning--text"
                         v-on="on">
                      {{ $helpers.toGermanFloatString(matrixPraemien['SB' + sbrow][productLine]) }}&nbsp;€
                    </div>
                  </template>
                  <span class="caption">Schubladentarif</span>
                </v-tooltip>
              </div>

              <div v-else
                   :key="productLine + '-' + sbrow"
                   class="tile--middle">&mdash;
              </div>

            </template>

          </v-row>

        </div>


      </div>

      <!--right part: SUS-->
      <div v-if="showSuS"
           id="sus">

        <div id="sus-headerline">
            <v-tooltip top
                       nudge-bottom="16">
              <template v-slot:activator="{on}">
                <span class="pt8"
                      v-on="on">Schnell & Sicher</span>
              </template>
              <span class="caption">Tarifname</span>
            </v-tooltip>
        </div>

        <div id="sus-container">

          <div id="vertical-line-container">
            &nbsp;
          </div>

          <div id="sus-box">

            <v-spacer />

            <v-container fluid class="pa-0">
              <v-row
                v-for="(text, idx) in ['Privat, Beruf, Verkehr, Wohnung', 'inklusive Spezial-Straf-Rechtsschutz', '300 € Selbstbeteiligung', 'nach 3 schadenfreien Jahren:<br>0 € Selbstbeteiligung', 'ein Jahr Laufzeit']"
                :key="'SuS' + idx"
                class="sus-row flex-nowrap"
                no-gutters
                align="center">

                <v-icon color="#FFCB05">check</v-icon>
                <span v-html="text"/>

              </v-row>
            </v-container>

            <v-spacer />

            <div id="sus-btn"
                 :class="matrixSelection==='SUS-SB300' ? 'selected' : ''"
                 class="tile--middle selectable"
                 @click="onSelectSchnellUndSicher">
              {{ $helpers.toGermanFloatString(matrixPraemien.sus) }}&nbsp;€
            </div>

          </div>

        </div>

      </div>

      <!--right part: YOLIG-->

        <div  v-if="getShowYoligMatrix" id="produkte-matrix-yolig">

        <div id="yolig-headerline">
            <v-tooltip top
              nudge-bottom="16">
              <template v-slot:activator="{on}">
                <span class="pt8"
                      v-on="on">YOLIG</span>
              </template>
              <span class="caption">Tarifname</span>
            </v-tooltip>
        </div>

        <div id="yolig-container">

          <div id="vertical-yolig-spacer">
            &nbsp;
          </div>

          <div id="yolig-box">
          <div id="yolig-innerbox">



          <v-row v-for="sbrow in matrixDefinition.rows"
                    :key="'sbrow'+sbrow"
                    no-gutters
                    class="sb--row flex-nowrap">

            <div class="yoligtile--left">
              <v-tooltip top
                         nudge-bottom="16">
                <template v-slot:activator="{on}">
                  <span class="pt8"
                        v-on="on">{{ sbrow }} €</span>
                </template>
                <span class="caption">Selbstbeteiligung</span>
              </v-tooltip>
            </div>

            <template v-for="productLine in ['YOLIG']">

              <div v-if="matrixAvailabilities['SB' + sbrow]['YOLIG'] === true"
                   :key="productLine + '-' + sbrow"
                   :class="matrixSelection===productLine + '-' + sbrow ? 'selected' : ''"
                   class="tile--middle selectable"
                   @click="onSelectPrice(productLine + '-' + sbrow)">
                <div>
                  {{ $helpers.toGermanFloatString(matrixPraemien['SB' + sbrow]['YOLIG']) }}&nbsp;€
                </div>

              </div>


              <div v-else-if="matrixAvailabilities['SB' + sbrow][productLine] === 'schublade'"
                   :key="productLine + '-' + sbrow"
                   :class="matrixSelection===productLine + '-' + sbrow ? 'selected' : ''"
                   class="tile--middle selectable"
                   @click="onSelectPrice(productLine + '-' + sbrow)">
                <v-tooltip top
                           nudge-bottom="8">
                  <template v-slot:activator="{on}">
                    <div class="warning--text"
                         v-on="on">
                      {{ $helpers.toGermanFloatString(matrixPraemien['SB' + sbrow][productLine]) }}&nbsp;€
                    </div>
                  </template>
                  <span class="caption">Schubladentarif</span>
                </v-tooltip>
              </div>

              <div v-else
                   :key="productLine + '-' + sbrow"
                   class="tile--middle">&mdash;
              </div>

            </template>

          </v-row>
          <v-row id="whatisyolig" class="flex-nowrap" align="center" justify="center">
            <div class="spacepadding">
              <router-link 
                to="/produkte/privatkunden/yolig" 
                color="white" 
                class="primary--text standard-button"
                target="_blank" >Unser nachhaltiger<br> Rechtsschutz 
              </router-link>
            </div>
            <site-tooltip close-delay="5000">
              <template v-slot:default>
                   <a href="#/produkte/privatkunden/yolig" target="_blank" class="primary--text" style="pointer-events: initial;"><strong>
                   YOLIG <v-icon size="16px" color="primary">open_in_new</v-icon></strong></a> 
                   ist Rechtsschutz für Menschen, die sich aktiv für ein zukunftsbewusstes Leben entscheiden und auf besondere 
                   Nachhaltigkeitsfaktoren Wert legen. YOLIG enthält darüber hinaus alle Leistungen der Produktlinie EXPERT
              </template>
            </site-tooltip>
          </v-row>
          </div>

        </div>
     </div>
   </div>



    </div>


  </div>
</template>
<script>
import {mapGetters} from "vuex";
import ValidationMixin from "@/components/helper/ValidationMixin";
import {mapTwoWay} from "@/store/twowayBindingMixin";
import twowayBinding from "@/store/twowayBindingMixin";
import {calculateSinglePraemie, productKeyFromCategories} from "@/helper/praemienHelper";

export default {
  mixins: [twowayBinding, ValidationMixin],
  data() {
    return {
      matrixSelection: ""
    };
  },
  computed: {
    getShowYoligMatrix: function() {
      return this.showYoligMatrix(this.statePath);
    },
    productMultipier: function() {
      return (this.showkfz && this.productKey(this.statePath) === "FzRS") ? (1 + this.showkfz) : 1;
    },
    ...mapGetters(["productKey", "tarifIsCharta", "isSusAvailable", "activeTarif", "isPraemieAvailable", "showYoligMatrix","getSecuroFaktor"]),
    ...mapTwoWay([
      "ssrselected",
      "sus",
      "tmpMatrixState",
      "civilServant",
      "family",
      "contractlength",
      "zahlweise",
      "categories",
      "sb",
      "productLine",
      "showkfz",
      "nurnachhaltig",
      "yoligrentner",
      "yoligazubi",
      "yoligekfz",
      "plzalter"]),
    tarifList() {
      return this.$store.state.praemien.tarifList;
    },
    showSuS: function () {
      return this.isSusAvailable && this.categories.length > 2 && !this.nurnachhaltig;
    },
    matrixDefinition() {
      const singleColumTarifs = ["web", "comfortplan", "mv", "mvmg", "securo", "securoplus", "securopremium"];
      if (singleColumTarifs.includes(this.activeTarif)) {
        const tarifDefinition = this.tarifList.find(tarif => tarif.value === this.activeTarif);
        return {
          columnHeaders: [tarifDefinition.shortText || tarifDefinition.text],
          rows: ['500', '300', '150', '0'],
          productLines: ['STD']
        };
      } else {
        return {
          columnHeaders: ['Standard', 'EXPERT', 'PRESTIGE'],
          rows: ['500', '300', '150', '0'],
          productLines: ['STD', 'EXP', 'PRE']
        };
      }
    },
    rawPraemien() {
      return this.$store.getters.rawPraemien;
    },
    matrixAvailabilities() {
      const availabilities = {};
      // if S&S is selected, we have to take values from backup state
      // verkehr not relevant if reading from tmp state, since S&S is not offered if only V is selected
      const productKey = this.sus ? productKeyFromCategories(this.tmpMatrixState.categories) : this.productKey(this.statePath);

      for (const sb of ['SB500', 'SB300', 'SB150', 'SB0']) {
        availabilities[sb] = {};
        for (const productLine of ['STD', 'EXP', 'PRE', 'YOLIG']) {
          availabilities[sb][productLine] = this.isPraemieAvailable(productKey, productLine, sb);
        }
      }
      return availabilities;
    },
    matrixPraemien() {
      const praemien = {};
      // if S&S is selected, we have to take values from backup state
      const family = this.sus ? this.tmpMatrixState.family : this.family;
      const contractlength = this.sus ? this.tmpMatrixState.contractlength : this.contractlength;
      // verkehr not relevant if reading from tmp state, since S&S is not offered if only V is selected
      const productKey = this.sus ? productKeyFromCategories(this.tmpMatrixState.categories) : this.productKey(this.statePath);
      let securoFaktor = this.getSecuroFaktor(this.statePath);
      for (const sb of ['SB500', 'SB300', 'SB150', 'SB0']) {
        praemien[sb] = {};
        for (const productLine of ['STD', 'EXP', 'PRE', 'YOLIG']) {
          if (this.isPraemieAvailable(productKey, productLine, sb)) {
            praemien[sb][productLine] = calculateSinglePraemie(
              this.rawPraemien,
              productKey,
              productLine,
              family,
              this.civilServant ? "B" : "N",
              sb,
              contractlength,
              this.zahlweise,
              this.$store.getters.rabatt(this.statePath),
              0,
              this.productMultipier,
              this.yoligrentner,
              this.yoligazubi,
              this.yoligekfz,
              securoFaktor
            );
          } else {
            praemien[sb][productLine] = 0;
          }
        }
      }
      praemien.sus = calculateSinglePraemie(
        this.rawPraemien,
        "S&S PBVW+SSR",
        "EXP",
        "MPH", // only available for MPH in index currently, though this is not set to tmp state
        "N", // only available for N in index currently, though this is not set to tmp state
        "SB300",
        "1",
        this.zahlweise,
        0 // sus does not allow rabatt
      );
      return praemien;
    }
  },
  watch: {
    sb(newValue) {
      if (!newValue) {
        this.matrixSelection = "";
      }
    }
  },
  created() {
    // restore matrix selection
    if (this.sus) {
      this.matrixSelection = 'SUS-SB300';
    } else if (this.sb && this.productLine) {
      this.matrixSelection = `${this.productLine}-${this.sb.slice(2)}`;
    }
  },
  methods: {
    onSelectPrice(event) {
      this.$emit('producterror');
      if (this.matrixSelection === 'SUS-SB300') {
        this.$store.commit("recoverMatrixState", { rootState: this.$store.state, statePath: this.statePath });
        this.$emit('info', {
          msg: "Die Änderung der Basisdaten für den Tarif Schnell & Sicher wurde verworfen."
        });
      }
      let selections = event.split("-");
      let payload = { sb: "", productLine: "", sus: false };
      this.matrixSelection = event;
      const prodLineSelected = selections.shift();
      if (prodLineSelected === 'YOLIG') {
        payload = { sb: "", productLine: "", sus: false, vn: {kommunikationEmail: true} };
      }
      payload.productLine = prodLineSelected;
      payload.sb = "SB" + selections.shift();
      payload = this.statePath === 'editContract' ? { editContract: payload } : { b: payload };
      this.$store.commit("setObject", payload);
      this.$store.commit("refreshZusatzbausteine", { rootState: this.$store.state, statePath: this.statePath });
    },
    onSelectSchnellUndSicher() {
      this.$emit('producterror');
      if (!this.sus) {
        this.$store.commit("saveMatrixState", { rootState: this.$store.state, statePath: this.statePath });
        this.$emit('info', {
          msg: "Die Basisdaten wurden für den Tarif Schnell & Sicher angepasst."
        });
        this.matrixSelection = 'SUS-SB300';
        let payload = {
          sb: "SB300",
          productLine: "EXP",
          sus: true,
          contractlength: "1",
          categories: ['P', 'B', 'V', 'W'],
          rabattProzent: 0,
          oekopunkte: 0
        };
        payload = this.statePath === 'editContract' ? { editContract: payload } : { b: payload };
        this.$store.commit("setObject", payload);
        this.$store.commit("refreshZusatzbausteine", { rootState: this.$store.state, statePath: this.statePath });
      }
    }
  }
};
</script>
<style>
#pricematrix {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
}

#pricematrix #produkte {
  width: 503px;
  margin: 0 auto;
}

#pricematrix #produkte-headerline {
  display: flex;
  flex-direction: row;
  width: 100%;
  padding-bottom: 14px;
}

#pricematrix #sus {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  max-width: 256px;
  min-width: 256px;
}

#pricematrix #sus-headerline {
  font-size: 16px !important;
  color: rgba(0, 0, 0, .87) !important;
  width: 100%;
  height: 63px;
  min-height: 63px;
  padding-left: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}
#pricematrix #yolig-headerline {
  font-size: 16px !important;
  color: rgba(0, 0, 0, .87) !important;
  width: 100%;
  height: 63px;
  min-height: 63px;
  padding-left: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
}

#yolig-innerbox {
  border: 3px solid #0085CF;
  border-radius: 5px;
  padding: 12px 16px 16px 16px;
  min-height: 401px;
  max-width: 232px;
  min-width: 232px;
  background: linear-gradient(#fff, #fff) padding-box, linear-gradient(90deg, #009ADA, #00539D, #3DAD48 ) border-box;
  border: 3px solid transparent;
}

#pricematrix .tile--top {
  font-size: 16px !important;
  background-color: white !important;
  color: rgba(0, 0, 0, .87) !important;
  border: none !important;
  width: 125px !important;
}

#pricematrix .tile--left {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  text-align: right;
  width: 40px;
  margin-right: 40px !important;
  font-size: 16px !important;
}
#pricematrix .yoligtile--left {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  text-align: right;
  width: 40px;
  margin-right: 24px !important;
  font-size: 16px !important;
}

#pricematrix .tile--middle {
  justify-content: center;
  background-color: #f5f5f5;
  font-size: 20px;
  color: #0085CF;
  padding: 0 16px !important;
  border-radius: 5px;
  text-align: center;
  border: 1px solid white;
  width: 125px !important;
  height: 63px;
  display: flex;
  align-items: center;
}

#pricematrix .sb--row + .sb--row {
  margin-top: 8px !important;
}

#pricematrix .tile--middle + .tile--middle {
  margin-left: 24px !important;
}

#pricematrix #sus-container {
  height: 100%;
  /*max-height: 276px;*/
  display: flex;
  flex-direction: row;
}
#pricematrix #yolig-container {
  height: 100%;
  /*max-height: 276px;*/
  display: flex;
  flex-direction: row;
}

#pricematrix #vertical-line-container {
  height: 100%;
  width: 24px !important;
  min-width: 24px !important;
}

#pricematrix #vertical-yolig-spacer {
  height: 100%;
  width: 24px !important;
  min-width: 24px !important;
}
@media screen and (max-width: 1505px) {
  #pricematrix #vertical-yolig-spacer {
     display: none;
  }
  #pricematrix #yolig-headerline {
     padding-left: 80px;
  }
}

#pricematrix #sus-box {
  height: 100%;
  min-height: 380px;
  border: 3px solid #FFCB05;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding-top: 12px;
}

#pricematrix #sus-box .sus-row {
  padding: 8px;
  font-size: 16px;
  color: #002C76;
}
#pricematrix #whatisyolig {
  padding: 8px;
  font-size: 16px;
  color: #002C76;
  margin-top: 28px;
  margin-bottom: 0px;
  margin-left: 0px;
  margin-right: 0px
}

#pricematrix #sus-box .sus-row .v-icon {
  margin-right: 8px !important;
}

#pricematrix #sus-box #sus-btn {
  margin: 8px auto 16px auto;
}

#pricematrix .iconsus {
  margin-left: 8px;
  /*margin: auto 8px auto auto;*/
  height: 32px;
}


@media screen and (max-width: 839px) {

  #pricematrix .tile--left {
    margin-right: 20px !important;
  }

  #pricematrix .tile--middle + .tile--middle {
    margin-left: 16px !important;
  }

}

#pricematrix .selectable {
  cursor: pointer;
}

#pricematrix .selectable:hover {
  border-color: #0085CF;
}

#pricematrix .selectable.selected {
  border-color: #0085CF;
  background-color: #0085CF;
  color: white;
}

#pricematrix .pt8 {
  padding-top: 8px;
}
</style>
